import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import ProductList from "pages/_components/product/List";
import { bool, func } from "prop-types";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getTransactionNumber } from "util/thirdPayment";
import NewLotPaymentItem from "./ItemRow";
import NewLotPaymentTitleColumns from "./TitleColumns";

const LotPaymentTable = React.memo(({ isDesktop, fromTransactionPage, showMoreLogs = null }) => {
    const { transactionLines } = useSelector((state) => state.form);
    const { pathname } = useLocation();
    const isPending = pathname.includes("pending");

    const getValidLines = (lines) => lines.filter((line) => !!line.cbu);
    const formatLines = (lines) =>
        lines
            .map((line) => ({
                cbu: line.creditCbu || line.cbu,
                creditAmountQuantity: line.creditAmountQuantity,
                cuit: isPending ? line.cuit : line.creditCuit,
                currency: line.creditAmountCurrency || line.currency,
                lineNumber: line.lineNumber,
                motivo: line.reference || line.motivo,
                productType: line.accountType || line.productType,
                referenc: line.referenc,
                voucher: line.voucher,
                status: isPending ? "PENDING" : line.status,
                transactionNumber:
                    !isPending && line.status === "PROCESSED"
                        ? getTransactionNumber(line?.extendedData, line?.status)
                        : "-",
            }))
            .filter((line) => !!line.cuit);

    const lines = fromTransactionPage ? formatLines(transactionLines?.list) : getValidLines(transactionLines?.list);
    const needWindowing = lines.length > 300;

    useEffect(() => {
        if (!transactionLines.lastPage) {
            if (showMoreLogs) {
                showMoreLogs();
            }
        }
    }, [!transactionLines.lastPage]);

    const RenderWindowingRow = React.memo((props) => {
        // eslint-disable-next-line react/prop-types
        const item = props?.data?.items[props?.index];

        return (
            // eslint-disable-next-line react/prop-types
            <div style={props.style}>
                <GridTable.Container columns={8}>
                    <NewLotPaymentItem paymentItem={item} isDesktop={isDesktop} />
                </GridTable.Container>
            </div>
        );
    });

    const RenderRow = (item) => (
        <GridTable.Container columns={8}>
            <NewLotPaymentItem paymentItem={item} isDesktop={isDesktop} />
        </GridTable.Container>
    );

    return (
        <>
            {lines?.length > 0 ? (
                <>
                    <h2>
                        <I18n id="lotPayment.table.title" />
                    </h2>

                    <ProductList
                        fetchingWithPreviousData
                        fetching={transactionLines?.fetching}
                        items={lines || []}
                        noDataText="global.no.results"
                        noFiltersDataText="global.no.results"
                        isWindowList={needWindowing}
                        renderItem={needWindowing ? RenderWindowingRow : RenderRow}>
                        {(listItem) => (
                            <GridTable
                                className={`detail-lotpayment-table tablelist underlined ${fromTransactionPage &&
                                    "fromTransactionPage"}`}>
                                <GridTable.Header>
                                    <GridTable.Container columns={fromTransactionPage ? 8 : 7}>
                                        <NewLotPaymentTitleColumns fromTransactionPage={fromTransactionPage} />
                                    </GridTable.Container>
                                </GridTable.Header>
                                <GridTable.Body>{listItem}</GridTable.Body>
                            </GridTable>
                        )}
                    </ProductList>
                </>
            ) : null}
        </>
    );
});

LotPaymentTable.propTypes = {
    isDesktop: bool.isRequired,
    fromTransactionPage: bool,
    showMoreLogs: func.isRequired,
};

LotPaymentTable.defaultProps = {
    fromTransactionPage: false,
};

export default LotPaymentTable;
